import { useMemo } from 'react'

import {
  DeleteAITrainingMaterialMutation,
  DeleteAITrainingMaterialMutationVariables,
  GetAllAITrainingMaterialsQuery,
  GetAllAITrainingMaterialsQueryVariables,
  UploadAITrainingMaterialFilesMutation,
  UploadAITrainingMaterialFilesMutationVariables,
} from 'types/graphql'
import { AIVectorStoreType } from 'types/graphql'

import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const GetAll = gql`
  query GetAllAITrainingMaterialsQuery($vectorStoreType: AIVectorStoreType!) {
    getAllAITrainingMaterials(vectorStoreType: $vectorStoreType) {
      ...AITrainingMaterialFragment
    }
  }
`
export const useGetAllAITrainingMaterialsQuery = (vectorStoreType: AIVectorStoreType) => {
  const { data, ...rest } = useQuery<
    GetAllAITrainingMaterialsQuery,
    GetAllAITrainingMaterialsQueryVariables
  >({
    queryKey: [QueryKey.GetAllAITrainingMaterials],
    queryDocument: GetAll,
    variables: { vectorStoreType },
  })
  const materials = useMemo(() => data?.getAllAITrainingMaterials || [], [data])
  return { ...rest, materials }
}

const Upload = gql`
  mutation UploadAITrainingMaterialFilesMutation($input: UploadAITrainingMaterialFilesInput!) {
    uploadAITrainingMaterialFiles(input: $input) {
      ...AITrainingMaterialFragment
    }
  }
`
export const useUploadAITrainingMaterialFilesMutation = () => {
  return useMutation<
    UploadAITrainingMaterialFilesMutation,
    UploadAITrainingMaterialFilesMutationVariables
  >({
    mutationDocument: Upload,
  })
}

const Delete = gql`
  mutation DeleteAITrainingMaterialMutation($id: Int!) {
    deleteAITrainingMaterial(id: $id) {
      id
    }
  }
`
export const useDeleteAITrainingMaterialMutation = () => {
  return useMutation<DeleteAITrainingMaterialMutation, DeleteAITrainingMaterialMutationVariables>({
    mutationDocument: Delete,
  })
}
